var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbstract3(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 124,
    viewBox: "0 0 356 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.193 69.6611C354.668 81.3424 355.481 109.99 356 124L2.50974e-05 124C2.60385e-05 102.47 3.30291 67.0083 26.611 57.2431C35.357 53.5789 47.6757 51.2575 56.8925 54.4928C59.3714 55.363 64.5221 60.0925 66.9029 59.9934C68.3218 59.9344 71.0515 42.5284 71.2408 41.8249C74.8925 28.2531 82.5784 17.6987 97.3512 15.2388C112.228 12.7616 132.079 10.5307 145.485 18.9892C149.782 21.701 152.198 24.5633 155.495 28.1568C161.456 34.6538 161.232 24.3391 163.754 19.0726C174.719 -3.83387 201.136 -3.34694 221.397 6.15457C233.778 11.9606 245.25 22.2205 254.515 31.9906C257.166 34.7868 265.856 55.8745 266.777 55.0763C274.15 48.6923 277.751 41.9429 287.966 38.8246C292.505 37.4389 300.009 37.9215 304.65 39.158C323.424 44.1595 334.869 54.0529 346.193 69.6611Z",
    fill: "#43BFAA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract3);
export default __webpack_public_path__ + "static/media/abstract-3.4a99c1ffec5ec61df9c7b5debf6407b4.svg";
export { ForwardRef as ReactComponent };